import { gql } from 'graphql-request'

export const GET_MY_EBOOK = gql`
  query GetEbookOverview(
    $limitPerPage: Int
    $page: Int
    $bookType: [BookType!]
    $categoryIds: [Int!]
    $name: String
    $penNameId: [Int!]
  ) {
    getEbookOverview(
      limitPerPage: $limitPerPage
      page: $page
      bookType: $bookType
      categoryIds: $categoryIds
      name: $name
      penNameId: $penNameId
    ) {
      data {
        coverImgPath
        title
        bookType
        totalEbookSeries
        avgEbookRating
        totalEbookReview
        totalEbookWishlist
        id
        totalEbookPurchaseCount
      }
      page
      total
    }
  }
`
